/**
 * Masks the last 4 characters of a vehicle number for guest users.
 * @param {string} vehicleNumber - Full vehicle number (e.g. MH12AB1234)
 * @param {boolean} isAuthenticated - Whether the user is logged in
 * @returns {string} - Masked (e.g. MH12AB****) or full vehicle number
 */
const maskVehicleNumber = (vehicleNumber, isAuthenticated) => {
  if (!vehicleNumber) return '';
  if (isAuthenticated) return vehicleNumber;
  if (vehicleNumber?.length <= 4) return '****';
  return vehicleNumber?.slice(0, -4) + '****';
};

export default maskVehicleNumber;
